import React, { Component } from 'react';
import Router from './Router';
import Master from './v5/components/Master';
import { Categories } from 'appSrc/api';

import './App.css';
import MainContainer from './v5/components/Main';

class Main extends Component {
    state = {
        areas: null,
        isAdmin: false,
    }
    componentDidMount() {
        // get available categories
        const isNotAdmin = window.location.href.indexOf( 'admin' ) < 0;
        this.setState({ isAdmin: !isNotAdmin });
        if (isNotAdmin) {
            // frontend header layout
            Categories.all( { sort: 'id,child_categories.id' } )
            .then( ( areas ) => {
                this.setState( {areas} );
            } );
        }
    }
    render() {
        const { areas, isAdmin } = this.state;
        return (
            <Master areas={areas}>
                <MainContainer isAdmin={isAdmin}>
                    <Router />
                </MainContainer>
            </Master>
        );
    }
}

export default Main;
